import { getHtmlLanguage, withQuery } from "utils/helpers"
import {
  CLASS_ID,
  DISABLE_MEMES,
  ENABLE_TIMER,
  GRAPHICAL_LOGIN,
} from "play/play-constants"
import { usePlayState } from "play/hooks/use-play-state"

interface TeacherOptions {
  isTeacher: true
  lessonId: string
  classId: string
  locale_code: string
  timerEnabled?: boolean
  disableMemes?: boolean
  enableGraphicalLogin: boolean
}

interface StudentOptions {
  isTeacher: false
  locale_code: string
}

export function generateLogoutLink(opts: TeacherOptions | StudentOptions) {
  if (opts.isTeacher) {
    const hash: any = {}
    hash[CLASS_ID] = opts.classId
    hash[GRAPHICAL_LOGIN] = opts.enableGraphicalLogin
    hash[ENABLE_TIMER] = !!opts.timerEnabled
    if (!!opts.disableMemes) {
      hash[DISABLE_MEMES] = opts.disableMemes
    }
    return withQuery(`/${opts.locale_code}/play/start/${opts.lessonId}`, hash)
  } else {
    return `/${opts.locale_code}/play`
  }
}

export function useLogout() {
  const locale_code = getHtmlLanguage()
  const {
    classId,
    isTeacherUrl,
    lessonId,
    timer,
    disableMemes,
    enableGraphicalLogin,
  } = usePlayState()

  return {
    logoutLink: generateLogoutLink({
      classId: classId || "",
      isTeacher: isTeacherUrl,
      lessonId: lessonId || "",
      locale_code,
      disableMemes,
      timerEnabled: timer.enabledForSession,
      enableGraphicalLogin,
    }),
  }
}
